import { TEST_PROJECT_WORDS } from './testProjectWords.ts';
import { Tag } from './ui.tsx';

/** The tag beside a test project's name (`testProjectWords.ts`). */
export function TestTag() {
  return <Tag>{TEST_PROJECT_WORDS.tag}</Tag>;
}

/** The box that makes a new project or lead a test project. */
export function TestProjectBox({ checked, onChange }: { checked: boolean; onChange: (checked: boolean) => void }) {
  return (
    <label className="label mt-2 flex min-h-11 items-center gap-2">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      {TEST_PROJECT_WORDS.choose}
    </label>
  );
}
